module.exports = __webpack_public_path__ + "static/media/gg.6a608369.svg";